<script setup lang="ts">
import {computed} from "vue";
import {QuestionFieldsPresenter} from "@/utils/presenters/QuestionFieldsPresenter.ts";
import ListDisplayType from "@/utils/constants/ListDisplayType.ts";
import QuestionListDefault from "./QuestionListDefault.vue";
import QuestionListDropdown from "./QuestionListDropdown.vue";
import QuestionListChips from "./QuestionListChips.vue";
import QuestionField = namaTypes.QuestionField;

const props = defineProps<{
  presenter: QuestionFieldsPresenter,
  questionField: QuestionField,
  doNotApplyThemeLayouts: boolean
}>()

const displayComponent = computed(() => {
  switch (props.questionField.listDisplayType) {
    case ListDisplayType.Dropdown:
      return QuestionListDropdown;
    case ListDisplayType.Chips:
      return QuestionListChips;
    default:
      return QuestionListDefault;
  }
});
</script>

<template>
  <component
    :is="displayComponent"
    :presenter="presenter"
    :questionField="questionField"
    :doNotApplyThemeLayouts="doNotApplyThemeLayouts"
  />
</template>
